export default __webpack_public_path__ + "static/media/Orpheus.dc27b761.woff2";